module.exports = __webpack_public_path__ + "static/assets/e43c93409f478be727f730410954c96d.png";